import { ProjectIssuanceTransactionPanelData } from "../../../../../../models";
import { SearchIssuanceTransactionsResponse } from "../../../../../../service/query";
import { Button, Column, Modal, Row } from "../../../../../../widget";
import { useReleaseToInventoryModal } from "./useReleaseToInventoryModal";

interface ReleaseToInventoryModalProps {
  type: string;
  show: boolean;
  onClose: () => void;
  handleRefresh: () => void;
  parentIssuanceTransaction: SearchIssuanceTransactionsResponse["results"][0];
  issuanceTransactionPanelData: ProjectIssuanceTransactionPanelData;
}
export const ReleaseToInventoryModal = ({
  type,
  show,
  onClose,
  handleRefresh,
  parentIssuanceTransaction,
  issuanceTransactionPanelData,
}: ReleaseToInventoryModalProps): JSX.Element => {
  const { handleReleaseToInventory, handleCancel } = useReleaseToInventoryModal({
    onClose,
    handleRefresh,
    parentIssuanceTransaction,
    issuanceTransactionPanelData,
  });
  return (
    <Modal show={show} title={`Release to inventory or keep ${type.toLowerCase()}?`} onClose={handleReleaseToInventory}>
      <Row justify="center" spacingV="2xl">
        <Column span={12}>
          <p className="body1">
            The parent transaction has been partially fulfilled. Would like to release the remaining
            {` ${type.toLowerCase()}`} units back to your available inventory or keep them {type.toLowerCase()} for this
            counterparty?
          </p>
        </Column>
      </Row>
      <Row justify="center">
        <Column span={12}>
          <Button text={`Keep ${type.toLowerCase()}`} onClick={handleCancel} />
          <Button variant="secondary" text="Cancel" onClick={handleReleaseToInventory} />
        </Column>
      </Row>
    </Modal>
  );
};
